import { WeekDay } from '@angular/common';
import { Deserializable } from '../protocols/deserializable';

export class DisplayOptionTimeDuration implements Deserializable {
  public startTime: string;
  public endTime: string;
  public days: WeekDay[];

  constructor() {
    this.startTime = '';
    this.endTime = '';
    this.days = [];
  }

  public onDeserialize() {
    this.days = Array.from(this.days || []);
  }
}
